import * as svg from "../../../assets/double-chevron-left.svg";

import {iconBuilder} from "./iconBuilder";

export const DoubleChevronLeftIcon = iconBuilder(svg, "DoubleChevronLeftIcon", "0 0 16 16");
